import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, fmt, fmtDate, ORDER_STATUS, stBadge } from '../api';
import { Loading, Empty, Eyebrow, ErrorBox, rowNav } from '../ui';

const TABS = [
  { key: 'ovr', label: 'Zakaz ↔ Kirim', desc: "har zakaz bo'yicha buyurtma / kelgan / farq" },
  { key: 'kilo', label: 'Kilo-Kub', desc: "zakazlar kesimida og'irlik va hajm — kargo hisobi uchun" },
  { key: 'supplier', label: 'Zavodlar', desc: "zavod kesimida yig'ma ko'rsatkichlar" },
];

export default function Reports() {
  const [tab, setTab] = useState('ovr');
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState('');
  const nav = useNavigate();

  // ⚠ Bo'limlar turli shakldagi javob qaytaradi (massiv yoki {rows,totals}).
  //   Bo'lim almashganda eski so'rovning javobi kechikib kelsa, u yangi bo'lim
  //   ustiga tushib sahifani yiqitardi. Shuning uchun faqat OXIRGI so'rov qabul
  //   qilinadi — qolganlari e'tiborsiz qoldiriladi.
  const reqId = useRef(0);
  const load = () => {
    const my = ++reqId.current;
    setData(null); setErr('');
    const url = tab === 'ovr' ? '/reports/order-vs-receipt' : tab === 'kilo' ? '/reports/kilo-cube' : '/reports/supplier-summary';
    api.get(url)
      .then((d) => { if (my === reqId.current) setData(d); })
      .catch((e) => { if (my === reqId.current) setErr(e.message); });
  };
  useEffect(load, [tab]);

  const active = TABS.find((t) => t.key === tab)!;

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Hisobotlar</h1>
          <p className="page-sub">Zakaz, kirim va yuk ko'rsatkichlari bo'yicha yig'ma hisobotlar</p>
        </div>
      </div>

      <div className="tabs">
        {TABS.map((t) => (
          <button key={t.key} className={'tab' + (tab === t.key ? ' active' : '')} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>

      <Eyebrow title={active.label} desc={active.desc} />

      {err ? <ErrorBox text={err} onRetry={load} /> : !data ? <Loading /> : (
        <>
          {tab === 'ovr' && (
            !Array.isArray(data) || data.length === 0 ? <Empty text="Ma'lumot yo'q" hint="Tasdiqlangan zakazlar paydo bo'lganda hisobot shakllanadi" /> : (
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Zakaz</th><th>Sana</th><th>Zavod</th><th>Status</th><th className="num">Buyurtma</th><th className="num">Keldi</th><th className="num">Farq</th><th className="num">Bajarilish</th></tr></thead>
                  <tbody>
                    {data.map((r: any) => (
                      <tr key={r.id} style={{ cursor: 'pointer' }} onClick={rowNav(() => nav('/orders/' + r.id))}>
                        <td className="link">{r.number}</td>
                        <td>{fmtDate(r.date)}</td>
                        <td>{r.supplier || '—'}</td>
                        <td><span className={'badge ' + stBadge(ORDER_STATUS, r.status).cls}>{stBadge(ORDER_STATUS, r.status).label}</span></td>
                        <td className="num">{fmt(r.ordered)}</td>
                        <td className="num">{fmt(r.received)}</td>
                        <td className="num">
                          {r.diff === 0 ? <span className="muted">0</span> : r.diff > 0 ? <span className="up">+{fmt(r.diff)}</span> : <span className="down">{fmt(r.diff)}</span>}
                        </td>
                        <td className="num" style={{ fontWeight: 600 }}>{r.pct == null ? '—' : fmt(r.pct, 1) + ' %'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}

          {tab === 'kilo' && (
            !Array.isArray(data?.rows) || !data.rows.length ? <Empty text="Ma'lumot yo'q" /> : (
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Zakaz</th><th>Sana</th><th>Zavod</th><th>Status</th><th className="num">Dona</th><th className="num">Mesta</th><th className="num">Kg</th><th className="num">m³</th></tr></thead>
                  <tbody>
                    {data.rows.map((r: any) => (
                      <tr key={r.id} style={{ cursor: 'pointer' }} onClick={rowNav(() => nav('/orders/' + r.id))}>
                        <td className="link">{r.number}</td>
                        <td>{fmtDate(r.date)}</td>
                        <td>{r.supplier || '—'}</td>
                        <td><span className={'badge ' + stBadge(ORDER_STATUS, r.status).cls}>{stBadge(ORDER_STATUS, r.status).label}</span></td>
                        <td className="num">{fmt(r.units)}</td>
                        <td className="num">{fmt(r.boxes, 1)}</td>
                        <td className="num">{fmt(r.kg, 1)}</td>
                        <td className="num">{fmt(r.m3, 2)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="total-row">
                      <td colSpan={4}>JAMI</td>
                      <td className="num">{fmt(data.totals.units)}</td>
                      <td className="num">{fmt(data.totals.boxes, 1)}</td>
                      <td className="num">{fmt(data.totals.kg, 1)}</td>
                      <td className="num">{fmt(data.totals.m3, 2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )
          )}

          {tab === 'supplier' && (
            !Array.isArray(data) || data.length === 0 ? <Empty text="Ma'lumot yo'q" /> : (
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Zavod</th><th className="num">Zakazlar</th><th className="num">Dona</th><th className="num">Mesta</th><th className="num">Kg</th><th className="num">m³</th><th className="num">Summa</th></tr></thead>
                  <tbody>
                    {data.map((r: any, i: number) => (
                      <tr key={i}>
                        <td style={{ fontWeight: 600 }}>{r.supplier}</td>
                        <td className="num">{r.orders}</td>
                        <td className="num">{fmt(r.units)}</td>
                        <td className="num">{fmt(r.boxes, 1)}</td>
                        <td className="num">{fmt(r.kg, 1)}</td>
                        <td className="num">{fmt(r.m3, 2)}</td>
                        <td className="num">
                          {!r.sums || Object.keys(r.sums).length === 0 ? '—'
                            : Object.entries(r.sums).map(([cur, v]) => `${fmt(v as number, 2)} ${cur}`).join(' + ')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
        </>
      )}
    </div>
  );
}
